import GcHeading from '../GcHeading/index.vue';
import GcCopy from '../GcCopy/index.vue';
import GcButton from '../GcButton/index.vue';

export default {
  name: 'GcCard',
  components: {
    GcHeading,
    GcCopy,
    GcButton,
  },
  methods: {
    ctasLocation(location) {
      if (location === 'stacked') {
        return {
          display: 'flex', 'flex-direction': 'column', 'justify-content': 'space-around', 'margin-left': 'auto', 'margin-bottom': '1.5rem',
        };
      }
      return {
        display: 'flex', 'justify-content': 'center', padding: '0 0 0 1rem', 'margin-bottom': '1.5rem',
      };
    },
  },
  props: {
    theme: {
      type: String,
      default: 'light',
    },
    width: {
      type: String,
      default: 'half',
    },
    imageOnly: {
      type: Boolean,
      default: false,
    },
    card: {
      type: Object,
      default: null,
    },
  },
};
